import store, { persistor } from "../redux/store";
import { clearAll } from "../redux/actions/hireActions";

const AUTH_KEY = "ECCO_IND_AUTH";
const LOGIN_DOC_KEY = "LOGIN_NRO_DOCUMENTO";

/**
 * Limpia token de contratación, login recordado, Redux hire y persist (IndexedDB).
 * Pensado para probar el flujo desde cero en local.
 */
export async function resetHireSession({
	redirectTo = "/individuales/productos/consulta",
	reload = true,
} = {}) {
	try {
		localStorage.removeItem(AUTH_KEY);
		localStorage.removeItem(LOGIN_DOC_KEY);
	} catch (e) {
		/* ignore */
	}

	try {
		sessionStorage.clear();
	} catch (e) {
		/* ignore */
	}

	store.dispatch(clearAll());

	try {
		await persistor.purge();
		await persistor.flush();
	} catch (e) {
		/* ignore */
	}

	if (reload && typeof window !== "undefined") {
		window.location.assign(redirectTo);
	}
}

export const installResetHireSessionGlobal = () => {
	if (typeof window === "undefined") return;
	window.__resetHireSession = resetHireSession;
};
